import { GeographicalService } from "../../../utils/common";
import { GeoService } from "../../../services/GeoService";
import { MAP_POINTER } from "../../../utils/constants";
import { LngLat, LocationDetails } from "./PCMiler.type";

export async function getLongitudeLatitude(
  stop: LocationDetails
): Promise<LngLat> {
  let {
    latLng,
    latLng: { lng, lat } = { lng: 0, lat: 0 },
    addressLine1
  } = stop;
  if (latLng && lng && lat) {
    return await GeographicalService.details.getLongitudeLatitude(lng, lat);
  } else {
    const updatedStop = { ...stop, address: addressLine1 || "" };
    let [stopCoordinate] = await GeographicalService.details.getCoordinates(
      updatedStop
    );
    const {  Lon = "0", Lat = "0"  } = stopCoordinate.Coords || {};
    return await GeographicalService.details.getLongitudeLatitude(parseFloat(Lon), parseFloat(Lat));
  }
}
export function renderMapStopMarkerAndPopup(
  latLng: LngLat,
  stopIndex: number,
  stopsLength: number,
  stopType: string,
  popupTitle: string,
  mapComponent: TrimbleMaps.Map
): TrimbleMaps.Marker {
  const { lng = 0, lat = 0 } = latLng;
  const svgContent = document.createElement("div");
  const {
    svg,
    height
  }: GeoService.StopMarker = GeographicalService.details.getStopMarker(
    stopIndex,
    stopsLength,
    stopType
  );
  svgContent.innerHTML = svg;
  svgContent.style.cursor = MAP_POINTER;
  const marker = GeographicalService.details
    .renderMarker(svgContent, lng, lat)
    .addTo(mapComponent);
  return renderMapStopMarkerPopup(marker, height, popupTitle);
}

function renderMapStopMarkerPopup(
  marker: any,
  markerHeight: number,
  popupTitle: string
): TrimbleMaps.Marker {
  const markerRadius: number = 10,
    linearOffset: number = markerHeight;
  const popupOffset: GeoService.Offset = {
    top: [0, 0],
    "top-left": [0, 0],
    "top-right": [0, 0],
    bottom: [0, -markerHeight],
    "bottom-left": [
      linearOffset,
      (markerHeight - markerRadius + linearOffset) * -1
    ],
    "bottom-right": [
      -linearOffset,
      (markerHeight - markerRadius + linearOffset) * -1
    ],
    left: [markerRadius, (markerHeight - markerRadius) * -1],
    right: [-markerRadius, (markerHeight - markerRadius) * -1]
  };
  const popup: TrimbleMaps.Popup = GeographicalService.details
    .renderPopup({
      closeOnClick: false,
      closeButton: true,
      offset: popupOffset
    })
    .setText(`${popupTitle}`);
  return marker.setPopup(popup);
}
